import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SingleLineNumberIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SingleLineNumber",
    children: /*#__PURE__*/_jsx("path", {
      d: "M6.41 13.87c-.25.29-.56.53-.96.72-.39.19-.82.3-1.27.32v-2.15c.69-.03 1.25-.22 1.69-.55.43-.34.71-.79.83-1.38h2.05v11.74H6.42v-8.71ZM10.73 22.19q0-1.155.42-2.04c.28-.59.62-1.09 1.01-1.5.4-.41.94-.9 1.62-1.46l.57-.45c.59-.47 1.05-.88 1.36-1.22.31-.35.47-.72.47-1.12 0-.48-.18-.87-.53-1.17q-.525-.45-1.47-.45-.735 0-1.44.33t-1.56 1.02h-.03v-2.26c1.15-.78 2.35-1.17 3.59-1.17.72 0 1.36.15 1.95.45a3.398 3.398 0 0 1 1.87 3.07c0 .56-.13 1.08-.39 1.55-.26.48-.56.88-.9 1.22q-.51.51-1.32 1.14l-.35.27c-.62.5-1.06.89-1.33 1.15s-.46.56-.59.9h5.03v2.16h-7.97l-.02-.39ZM21.45 22.48c-.57-.17-1.05-.37-1.43-.6v-2.45h.03c1 .75 2.04 1.12 3.14 1.12.65 0 1.16-.17 1.54-.5s.57-.76.57-1.3-.19-.94-.58-1.27-.93-.5-1.64-.5H21.6v-.08l2.26-3.92h-3.72v-2.16h7.15v.13l-2.52 4.46c.87.18 1.57.58 2.08 1.22.51.63.77 1.37.77 2.22 0 .74-.18 1.4-.55 2s-.88 1.05-1.53 1.38c-.66.33-1.42.5-2.26.5-.66 0-1.27-.09-1.84-.26Z"
    })
  }));
};
SingleLineNumberIcon.displayName = 'SingleLineNumberIcon';